"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumSheetSymbol = void 0;
exports.withDefaultSchDocExtension = withDefaultSchDocExtension;
const SchDocTypes_1 = require("../SchDocTypes");
const altiumFileTypes_1 = require("../../../altiumFileTypes");
function withDefaultSchDocExtension(reference) {
    if (!reference || reference.toLowerCase().endsWith(altiumFileTypes_1.AltiumFileType.SchDoc.toLowerCase())) {
        return reference;
    }
    return `${reference}${altiumFileTypes_1.AltiumFileType.SchDoc}`;
}
class AltiumSheetSymbol {
    constructor(schematic, record) {
        this.schematic = schematic;
        this.record = record;
    }
    get uniqueId() {
        return this.record.uniqueId;
    }
    getEntries() {
        if (!this._entries) {
            const children = this.schematic.getChildRecords(this.record.index);
            this._entries = children.filter((r) => r.recordType === SchDocTypes_1.RecordType.SHEET_ENTRY);
        }
        return this._entries;
    }
    getSheetName() {
        if (!this._sheetName) {
            const children = this.schematic.getChildRecords(this.record.index);
            const record = children.find((r) => r.recordType === SchDocTypes_1.RecordType.SHEET_NAME);
            if (!record) {
                throw new Error(`Sheet symbol ${this.record.index} has no sheet name`);
            }
            this._sheetName = record;
        }
        return this._sheetName;
    }
    getFileName() {
        if (!this._fileName) {
            const children = this.schematic.getChildRecords(this.record.index);
            const record = children.find((r) => r.recordType === SchDocTypes_1.RecordType.FILE_NAME);
            if (!record) {
                throw new Error(`Sheet symbol ${this.record.index} has no file name`);
            }
            this._fileName = record;
        }
        return this._fileName;
    }
    getSheetNameText() {
        return this.getSheetName().text;
    }
    getFileNameText() {
        return this.getFileName().text;
    }
    getEntryByName(name) {
        return this.getEntries().find((e) => e.name === name);
    }
}
exports.AltiumSheetSymbol = AltiumSheetSymbol;
//# sourceMappingURL=AltiumSheetSymbol.js.map